import { useParams, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import Artwork from '../components/Artwork';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import ArtworksCarousel from '../components/ArtworksCarousel';
import { useGetArtworksQuery } from '../slices/artworksApiSlice';

const HomeScreen = () => {
  const { pageNumber, keyword } = useParams();
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem('galleryUrl', location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageNumber]);
  const { data, isLoading, error } = useGetArtworksQuery({
    keyword,
    pageNumber,
  });
  const isFirstPage = !keyword && (!pageNumber || pageNumber === '1');

  return (
    <>
      {keyword && (
        <Link to="/" className="btn btn-light mb-4">
          Go Back
        </Link>
      )}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <>
          {/* <h2>Latest artworks</h2> */}
          <Row>
            {isFirstPage && (
              <Col sm={12} md={6} lg={4} xl={3}>
                <div className="py-3">
                  <ArtworksCarousel />
                </div>
              </Col>
            )}
            {data.artworks.map((artwork) => (
              <Col key={`artwork-${artwork._id}`} sm={12} md={6} lg={4} xl={3}>
                <Artwork artwork={artwork} />
              </Col>
            ))}
          </Row>
          <Paginate
            pages={data.pages}
            page={data.page}
            keyword={keyword ? keyword : ''}
          />
        </>
      )}
    </>
  );
};

export default HomeScreen;
